export interface CommentarySegment { text: string; participant: 1 | 2 | null }

/**
 * Splits a commentary into plain and highlighted segments, so it can be rendered
 * with text interpolation instead of v-html. At each position the longest
 * matching name wins, so a full name is highlighted once, not its last name inside it.
 */
export function highlightParticipantNames(
    text: string,
    participantOneNames: (string | undefined)[],
    participantTwoNames: (string | undefined)[],
): CommentarySegment[] {
    const names = [
        ...participantOneNames.map(name => ({ name, participant: 1 as const })),
        ...participantTwoNames.map(name => ({ name, participant: 2 as const })),
    ]
        .filter((entry): entry is { name: string; participant: 1 | 2 } => !!entry.name)
        .sort((a, b) => b.name.length - a.name.length);

    const segments: CommentarySegment[] = [];
    let plain = '';
    let position = 0;
    while (position < text.length) {
        const match = names.find(({ name }) => text.startsWith(name, position));
        if (!match) {
            plain += text[position];
            position++;
            continue;
        }
        if (plain) {
            segments.push({ text: plain, participant: null });
            plain = '';
        }
        segments.push({ text: match.name, participant: match.participant });
        position += match.name.length;
    }
    if (plain) {
        segments.push({ text: plain, participant: null });
    }

    return segments;
}
